import React, { FC } from 'react';
import { Box, Alert, Typography, makeStyles } from '@dxb-web-ui-framework/design-system';

type ErrorAlertProps = {
  message?: string;
  hasSpacing?: boolean;
};

const useStyles = makeStyles(theme => ({
  errorAlert: ({ hasSpacing }: { hasSpacing?: boolean }) => ({
    paddingBottom: !hasSpacing ? theme.spacing(2) : '',
    padding: hasSpacing ? `${theme.spacing(4)}px ${theme.spacing(3)}px` : '',
    [theme.breakpoints.down('sm')]: {
      padding: hasSpacing ? `${theme.spacing(3)}px 0px` : '',
    },
  }),
}));

const ErrorAlert: FC<ErrorAlertProps> = ({ message, hasSpacing }) => {
  const classes = useStyles({ hasSpacing });

  return (
    <Box className={classes.errorAlert}>
      <Alert icon={false} severity='error' variant='filled'>
        <Typography component={'span'} variant='body1'>
          {message}
        </Typography>
      </Alert>
    </Box>
  );
};

export { ErrorAlert };
